import { clsx } from 'clsx';

type Props = {
  label: string;
  value: number;
  min?: number;
  max?: number;
  displayValue?: string;
  onChange?: (value: number) => void;
};

/**
 * Disabled i denna version - bara visuell presentation.
 * TODO: koppla pa onChange nar state-management for justeringar ar pa plats.
 */
export function Slider({ label, value, min = 0, max = 100, displayValue }: Props) {
  const pct = Math.max(0, Math.min(100, ((value - min) / (max - min)) * 100));
  return (
    <div className="flex items-center gap-3 mb-2">
      <div className="text-xs text-text-muted w-[68px]">{label}</div>
      <div className="relative flex-1 h-[5px] bg-bg-elevated rounded-[3px] cursor-pointer">
        <div
          className="absolute top-0 bottom-0 bg-accent rounded-[3px]"
          style={{ width: `${pct}%` }}
        />
        <div
          className={clsx(
            'absolute top-1/2 w-[12px] h-[12px] -translate-x-1/2 -translate-y-1/2',
            'rounded-full bg-white shadow',
          )}
          style={{ left: `${pct}%` }}
        />
      </div>
      <div className="font-mono text-[11px] text-text-muted min-w-[38px] text-right font-medium">
        {displayValue ?? value.toString()}
      </div>
    </div>
  );
}
